import { ChangeDetectorRef, Directive, HostListener, Input } from '@angular/core';
import { firstValueFrom, isObservable, Observable } from 'rxjs';
import { ButtonLoaderComponent } from '../components/button-loader/button-loader.component';
import { ensureMinimumTime } from '../functions/util';

@Directive({
  selector: '[mriIeActionLoader]'
})
export class ActionLoaderDirective {
  @Input('mriIeActionLoader') action?: (actionParam: unknown) => Promise<void> | Observable<unknown>;
  @Input() actionParam?: unknown;

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly loaderComponent: ButtonLoaderComponent
  ) {
    if (!this.loaderComponent) {
      throw new Error('ActionLoader requires mriIeButtonLoader on the same element');
    }
  }

  @HostListener('click')
  async handleClick() {
    if (!this.action || this.loaderComponent.isLoading) return;

    try {
      this.loaderComponent.isLoading = true;
      const result = this.action(this.actionParam);
      const promiseResult = isObservable(result) ? firstValueFrom(result) : result;
      await ensureMinimumTime(promiseResult);
    } catch (e) {
      console.error(e);
    } finally {
      this.loaderComponent.isLoading = false;
      this.cdr.markForCheck();
    }
  }
}
